import Layout from '@/views/layout/Layout'

const systemRouter = [
    {
        path: '/',
        component: Layout,
        name: 'welcome',
        alwaysShow: false,
        hidden: true,
        meta: {
            role: ['admin'],
            title: '欢迎页',
            icon: 'fa fa-home',
            noCache: true
        },
        children: [
            {
                path: '/welcome',
                component: () => import('@/views/Welcome.vue'),
                meta: {
                    role: ['admin'],
                    title: '欢迎页',
                    icon: 'fa fa-home',
                    noCache: true
                },
                name: 'welcomeIndex',
                hidden: true
            }
        ]
    },{
    path: '/order',
    component: Layout,
    redirect: '/order/index',
    name: 'order',
    meta: { role: "admin", title: '订单管理', icon: 'example', noCache: true },
    children: [{
        path: 'orders',
        name: 'orders',
        component: () => import('@/views/order/index'),
        meta: { role: "admin",title: '订单管理', icon: 'form', noCache: true }
    },]
},{
    path: '/boxs',
    component: Layout,
    redirect: '/boxs/index',
    name: 'boxs',
    meta: { role: "admin", title: '盲盒管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'boxsIndex',
        hidden: false,
        component: () => import('@/views/boxs/index'),
        meta: { role: "admin",title: '盲盒列表', icon: 'form', noCache: true },
    },{
        path: 'edit',
        hidden: true,
        name: 'boxsEdit',
        component: () => import('@/views/boxs/edit'),
        meta: { role: "admin",title: '编辑盲盒', icon: 'form', noCache: true }
    },]
},
    {
        path: '/products',
        component: Layout,
        redirect: '/products/index',
        name: 'products',
        meta: { role: "admin", title: '商品管理', icon: 'form', noCache: true },
        children: [{
            path: 'index',
            name: 'productsIndex',
            hidden: true,
            component: () => import('@/views/products/index'),
            meta: { role: "admin",title: '商品列表', icon: 'example', noCache: true }
        },{
            path: 'edit',
            hidden: true,
            name: 'productsEdit',
            component: () => import('@/views/products/edit'),
            meta: { role: "admin",title: '编辑商品', icon: 'form', noCache: true }
        },{
            path: 'add',
            hidden: true,
            name: 'productsAdd',
            component: () => import('@/views/products/add'),
            meta: { role: "admin",title: '新增商品', icon: 'form', noCache: true }
        },{
            path: 'orders',
            name: 'productsOrders',
            hidden: true,
            component: () => import('@/views/orders/index'),
            meta: { role: "admin",title: '订单管理', icon: 'form', noCache: true }
        },]
    }, {
    path: '/user',
    component: Layout,
    redirect: '/user/index',
    alwaysShow: true,
    meta: { role: "admin", title: '用户管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'userIndex',
        alwaysShow: true,
        component: () => import('@/views/user/index'),
        meta: { role: "admin",title: '用户管理', icon: 'form', noCache: false }
    },{
        path: 'changeAmount',
            name: 'changeAmount',
            alwaysShow: true,
            component: () => import('@/views/user/changeAmount'),
            meta: { role: "admin",title: '修改余额记录', icon: 'form', noCache: false }
    }]
},
    {
    path: '/moneys',
    component: Layout,
    redirect: '/moneys/index',
    name: 'moneys',
    meta: { role: "admin", title: '财务管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'moneyIndex',
        component: () => import('@/views/moneys/index'),
        meta: { role: "admin",title: '交易总览', icon: 'example', noCache: true }
    },
        {
            path: 'expense',
            name: 'moneyExpense',
            component: () => import('@/views/moneys/expense'),
            meta: { role: "admin",title: '消费数据', icon: 'example', noCache: true }
        },
        {
            path: 'data',
            name: 'moneyData',
            component: () => import('@/views/moneys/data'),
            meta: { role: "admin",title: '收支数据', icon: 'example', noCache: true }
        },
        {
            path: 'withdraw',
            name: 'withdraw',
            component: () => import('@/views/moneys/withdraw'),
            meta: { role: "admin",title: '提现审核', icon: 'example', noCache: true }
        }]
},
    {
        path: '/marketing',
        component: Layout,
        redirect: '/marketing/platform',
        name: 'marketing',
        meta: { role: "admin", title: '营销管理', icon: 'example', noCache: true },
        children: [{
            path: 'platform',
            name: 'marketingPlatform',
            component: () => import('@/views/marketing/platform'),
            meta: { role: "admin",title: '平台数据', icon: 'example', noCache: true }
        },
            {
                path: 'user',
                name: 'marketingUser',
                component: () => import('@/views/marketing/user'),
                meta: { role: "admin",title: '消费数据', icon: 'example', noCache: true }
            }]
    },
    {
        path: '/setting',
        component: Layout,
        redirect: '/setting/index',
        name: 'setting',
        meta: { role: "admin", title: '配置', icon: 'el-icon-setting', noCache: true },
        children: [{
            path: 'index',
            name: 'settingIndex',
            component: () => import('@/views/setting/index'),
            meta: { role: "admin",title: '配置', icon: 'example', noCache: true }
        }]
    }
]

 export default systemRouter



// WEBPACK FOOTER //
// ./src/router/modules/systemRouter.js